import { Box, Typography } from "@mui/material";
import { ContactInfo } from "../../AtomicDesign/Molecules";
import { Header } from "../Header";
import { GlobalContainer } from "../../AtomicDesign/Atoms";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Nuvens from "../../../assets/images/coelho/imagem  nuvens.png";
import Estrelas from "../../../assets/images/coelho/estrelinhas.png";
import { useBreakpoints } from "../../../hooks/useBreakpoins";

export function MainLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isSmalldesktop } = useBreakpoints();

  useEffect(() => {
    window?.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);
  // if (user && token) {
  //   if (user.user.role === "admin") {
  //     navigate("/treasurebox-app/admin");
  //   } else {
  //     navigate("/treasurebox-app");
  //   }
  // }

  useEffect(() => {
    if (pathname === "/") {
      navigate("/home?tab=0");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      minWidth={"100%"}
      minHeight={"100vh"}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"space-between"}
      sx={{
        backgroundImage: `url(${Estrelas}), linear-gradient(#FFFFFF, #E6DFFF)`,
      }}
    >
      <Box
        sx={{
          width: "100%",
          mb: 30,
        }}
      >
        <Header />
      </Box>

      {/* <Container
        maxWidth={"xl"}
        sx={{
          mt: 2,
          mb: 2,
          display: "flex",
          justifyContent: "center",
        }}
      >
       
      </Container> */}
      <Box
        sx={{
          width: "100%",
          mt: 3,
          background: "#FFFFFF",
        }}
      >
        <Box
          display={"flex"}
          width={"100%"}
          sx={{
            marginTop: -30,
            mb: isSmalldesktop ? 0 : "-10%",
          }}
        >
          <img
            src={Nuvens}
            alt="imagem de nuvens rodape"
            width={isSmalldesktop ? "100%" : "50%"}
            style={{ minHeight: 250 }}
          />

          {!isSmalldesktop && (
            <img
              src={Nuvens}
              alt="imagem de nuvens rodape"
              width={"50%%"}
              style={{
                transform: "scaleX(-1)",
              }}
            />
          )}
        </Box>
        <GlobalContainer sx={{ mt: 2, mb: 2 }}>
          <ContactInfo />
          <Typography textAlign={"center"} mt={10}>
            {String(new Date().getFullYear())} © Coelho Mágico
          </Typography>
        </GlobalContainer>
      </Box>
    </Box>
  );
}
